import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'

export const NAME = 'overlays'

const byId = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      let byId = {}
      action.overlays.forEach(overlay => (byId[overlay.id] = overlay))
      return byId
    case ActionTypes.FETCH_START:
      return {}
    default:
      return state
  }
}

const allKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return []
    case ActionTypes.FETCH_SUCCESS:
      return action.overlays.map(overlay => overlay.id)
    default:
      return state
  }
}

const selected = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE:
      return {
        ...state,
        [action.id]: !state[action.id]
      }
    default:
      return state
  }
}

const overlays = combineReducers({
  byId,
  allKeys,
  selected
})

export default overlays
